import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckDateOptions } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { parseStringDate } from '@utils/date';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { TCMDatesMavenirDatesDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_DATES_OPTIONS } from '@constants/queryKeys';

type TUseQueryHistoryCheckDatesOptions = TCMDatesMavenirDatesDTO & ICMMavenirVendor;

interface IUseQueryHistoryCheckDatesOptionsReturnValue {
	dateOptions: Date[];
	isFetchingDateOptions: boolean;
	isLoadingDateOptions: boolean;
}

export const useQueryHistoryCheckDatesOptions = (
	params: TUseQueryHistoryCheckDatesOptions,
): IUseQueryHistoryCheckDatesOptionsReturnValue => {
	const {
		vendor,
		type,
		nodes,
		version,
		isMavenirVendor,
	} = params;

	const {
		data: dateOptions,
		isFetching: isFetchingDateOptions,
		isLoading: isLoadingDateOptions,
	} = useQuery<string[], Date[]>({
		queryKey: [HISTORY_CHECK_DATES_OPTIONS, params],
		queryFn: extractQueryParams(getHistoryCheckDateOptions),
		select: (dates) => dates?.map((date) => parseStringDate(date)),
		enabled: [
			isMavenirVendor,
			!!vendor,
			!!version,
			!!type,
			!!nodes.length,
		],
		...refetchOptions,
	});

	return {
		dateOptions: dateOptions || [],
		isFetchingDateOptions,
		isLoadingDateOptions: (isLoadingDateOptions && !!dateOptions) || isFetchingDateOptions,
	};
};
